import React, { useState, useEffect } from "react";
import { NotificationManager } from "react-notifications";
import { Quantum } from 'ldrs/react';
import 'ldrs/react/Quantum.css';
import "../assets/css/customerCards.css";
import { handleWheel, handleMouseEnter, handleMouseLeave } from '../utils/Scroll';
import DashboardFooter from "../components/DashboardFooter";

const AddCustomer = () => {
  const [customer, setCustomer] = useState({
    id: null,
    name: "",
    email: "",
    number: "",
    zipcode: "",
    city: "",
    address: "",
    longitude: "",
    latitude: "",
    gender: ""
  });

  const [customersList, setCustomersList] = useState([]);
  const [searchFilters, setSearchFilters] = useState({
    name: "",
    email: "",
    phone: "",
    city: ""
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [customerToDelete, setCustomerToDelete] = useState(null);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");


  // Handle input change
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setCustomer((prev) => ({
      ...prev,
      [name]: type === "number" ? parseFloat(value) : value,
    }));
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchFilters((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const resetCustomerForm = () => {
  setCustomer({
    id: null,
    name: "",
    email: "",
    number: "",
    zipcode: "",
    city: "",
    address: "",
    longitude: "",
    latitude: "",
    gender: ""
  });
};

  // Add new customer (POST)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: customer.name,
      phone: customer.number,
      gender: customer.gender,
      email: customer.email?.trim()=== "" ? null :customer.email,
      address: customer.address,
      lat: customer.latitude?.toString(),
      lon: customer.longitude?.toString(),
      city: customer.city,
      zip_code: customer.zipcode,
    };

    try {
      setLoading(true);
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/admin-user/customers/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Failed to add customer");

      const data = await res.json();
      setCustomer({ ...customer, id: data.id });
      NotificationManager.success("Customer added successfully");
   resetCustomerForm();
      fetchAllCustomers();
    } catch (err) {
      console.error(err);
      NotificationManager.error("Error adding customer");
    } finally {
      setLoading(false);
    }
  };

  // Update customer (PUT)
  const handleUpdate = async () => {
    if (!customer.id) return NotificationManager.error("Customer ID missing");

    const payload = {
      id: customer.id,
      name: customer.name,
      phone: customer.number,
      gender: customer.gender,
      email: customer.email?.trim()=== ""? null : customer.email,
      address: customer.address,
      lat: customer.latitude?.toString(),
      lon: customer.longitude?.toString(),
      city: customer.city,
      zip_code: customer.zipcode,
    };

    try {
      setLoading(true);
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/admin-user/customers/${customer.id}/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Failed to update customer");

      const data = await res.json();
      NotificationManager.success("Customer updated successfully");
      resetCustomerForm()
      fetchAllCustomers();
    } catch (err) {
      console.error(err);
      NotificationManager.error("Error updating customer");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (id) => {
    const customer = customersList.find(c => c.id === id);
    setCustomerToDelete(customer);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (!customerToDelete) return;

    try {
      setLoading(true);
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/admin-user/customers/${customerToDelete.id}/`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("token", token)
      console.log(res.status)
      if (res.status !== 204) throw new Error("Failed to delete customer",);

      NotificationManager.success(`${customerToDelete.name} deleted successfully`);
      fetchAllCustomers(); // Refresh list

      // Reset form if the deleted customer was being edited
      if (customer.id === customerToDelete.id) {
        setCustomer({
          id: null,
          name: "",
          email: "",
          number: "",
          zipcode: "",
          city: "",
          address: "",
          longitude: "",
          latitude: "",
          gender: ""
        });
      }

      // Close modal and reset state
      setShowDeleteModal(false);
      setCustomerToDelete(null);
    } catch (err) {
      console.error(err);
      NotificationManager.error("Error deleting customer");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setCustomerToDelete(null);
  };


  const fetchAllCustomers = async () => {
    try {
      let url = `${process.env.REACT_APP_HOST_API_URL}/admin-user/customers/?`;
      const params = new URLSearchParams();

      Object.entries(searchFilters).forEach(([key, value]) => {
        if (value) params.append(key, value);
      });

      url += params.toString();

      const res = await fetch(url, {
        headers: { Authorization: "Bearer " + token },
      });

      if (!res.ok) throw new Error("Failed to fetch customers");

      const data = await res.json();
      setCustomersList(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchAllCustomers();
  }, []);

  // Cleanup effect to restore body scroll when component unmounts
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);



  if (loading) return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '700px' }}>
      <Quantum
        size="45"
        speed="1.75"
        color="blue" 
      />
    </div>
  );

  return (
     <div className="d-flex flex-column min-vh-100 pb-2 px-3">
    {/* Main content area (scrolls normally) */}
    <div className="flex-grow-1">
    <div className="container-fluid pb-2 px-2 px-md-4" style={{paddingTop: '20px'}}>
      {/* Page Heading */}

      <div className="row mb-4 bg-white shadow-sm border-bottom sticky-top py-3 px-md-3 px-2 rounded  " 
       style={{
          zIndex: 1050,
       background:"linear-gradient(135deg, #0564bf, #89CFF0"
        }}>
        <div className="col-12">
          <h3 className="text-light mb-1">
            Add New Customer
          </h3>
          <p className="text-light mb-0">
            Create and manage customer information for appointments and services
          </p>
        </div>
      </div>
      
      <div className="row">
        {/* Customer Form */}
        <div className="col-12 col-lg-8 mb-4" 
        // style={{ paddingRight: '50px', paddingLeft: '50px' }}
        >
          <div className="border rounded p-3 bg-white shadow-sm">
            <h4 className="text-center mb-4" style={{ color: "#0564bf" }}>
              {customer.id ? "Update Customer" : "Add Customer"}
            </h4>
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                
                <div className="col-12 col-md-6">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={customer.name}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className=" col-12 col-md-6">
                  <input
                    type="text"
                    name="number"
                    placeholder="Phone Number"
                    value={customer.number}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className=" col-12 col-md-6">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={customer.email}
                    onChange={handleChange}
                    className="form-control"
                   
                  />
                </div>

                <div className=" col-12 col-md-6">
                  <select
                    name="gender"
                    value={customer.gender}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
    
                <div className="col-12 col-md-6">
                  <input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={customer.city}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="col-12 col-md-6">
                  <input
                    type="text"
                    name="zipcode"
                    placeholder="ZipCode"
                    value={customer.zipcode}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                <div className="col-12 col-md-6">
                  <input
                    type="number"
                    name="longitude"
                    placeholder="Longitude"
                    value={customer.longitude}
                    onChange={handleChange}
                    className="form-control"
                    disabled
                  />
                </div>

                <div className="col-12 col-md-6">
                  <input
                    type="number"
                    name="latitude"
                    placeholder="Latitude"
                    value={customer.latitude}
                    onChange={handleChange}
                    className="form-control"
                    disabled
                  />
                </div>

                <div className="col-12">
                  <textarea
                    name="address"
                    placeholder="Address"
                    value={customer.address}
                    onChange={handleChange}
                    className="form-control"
                    rows={3}
                  />
                </div>
              </div>

              <div className="d-flex justify-content-center gap-3 mt-4 flex-wrap">
                {!customer.id && (
                  <button type="submit" className="btn btn-outline-primary px-4">
                    Save
                  </button>
                )}
                {customer.id && (
                  <button
                    type="button"
                    className="btn btn-outline-primary px-4"
                    onClick={handleUpdate}
                  >
                    Update
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>


        <div className="col-12 col-lg-4 mb-4">
          <div className="border rounded p-3 bg-white shadow-sm d-flex flex-column">
            <h4 className="text-center mb-4" style={{ color: "#0564bf" }}>
              All Customers
            </h4>
            
            {/* Search Filters */}
            <div className="search-container mb-3">
              <div className="row g-2">
                <div className="col-12">
                  <input
                    type="text"
                    name="name"
                    placeholder="Search by name..."
                    value={searchFilters.name}
                    onChange={handleSearchChange}
                    className="form-control form-control-sm search-input"
                  />
                </div>
                <div className="col-6">
                  <input
                    type="text"
                    name="city"
                    placeholder="City..."
                    value={searchFilters.city}
                    onChange={handleSearchChange}
                    className="form-control form-control-sm search-input"
                  />
                </div>
                <div className="col-6">
                  <input
                    type="text"
                    name="phone"
                    placeholder="Phone..."
                    value={searchFilters.phone}
                    onChange={handleSearchChange}
                    className="form-control form-control-sm search-input"
                  />
                </div>
              </div>
              <button 
                className="btn btn-sm btn-primary mt-2 w-100 search-btn"
                onClick={fetchAllCustomers}
              >
                <i className="fas fa-search me-1"></i> Search
              </button>
            </div>

            {/* Customer Cards */}
            <div 
              className="flex-grow-1 overflow-auto customer-cards-container" 
              style={{ maxHeight: '100vh' }}
              onWheel={handleWheel}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {customersList.map((c) => (
                <div
                  key={c.id}
                  className="customer-card mb-3 p-3"
                  onClick={() =>
                    setCustomer({
                      id: c.id,
                      name: c.name,
                      email: c.email,
                      number: c.phone,
                      zipcode: c.zip_code,
                      city: c.city,
                      address: c.address,
                      longitude: parseFloat(c.lon),
                      latitude: parseFloat(c.lat),
                      gender: c.gender
                    })
                  }
                >
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="d-flex align-items-center">
                      <div 
                        className={`customer-avatar rounded-circle d-flex align-items-center justify-content-center me-2 ${
                          c.gender === "Female" ? "female" : c.gender === "Other" ? "other" : ""
                        }`}
                        style={{
                          width: "40px",
                          height: "40px",
                          color: "white",
                          fontSize: "14px",
                          fontWeight: "bold"
                        }}
                      >
                        {c.name.charAt(0).toUpperCase()}
                      </div>
                      <div>
                        <h6 className="mb-0 fw-bold" style={{ color: "#0564bf" }}>
                          {c.name}
                        </h6>
                        <small className="text-muted">
                          {c.gender} • ID: {c.id}
                        </small>
                      </div>
                    </div>
                    <span 
                      className={`status-badge badge ${c.status ? 'bg-success' : 'bg-secondary'}`}
                    >
                      {c.status ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                  
                  <div className="row g-2 mb-2">
                    <div className="col-12">
                      <div className="d-flex align-items-center customer-info-item">
                        <i className="fas fa-envelope me-2 text-muted" style={{ fontSize: "12px" }}></i>
                        <small className="text-truncate">{c.email}</small>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-center customer-info-item">
                        <i className="fas fa-phone me-2 text-muted" style={{ fontSize: "12px" }}></i>
                        <small>{c.phone}</small>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-center customer-info-item">
                        <i className="fas fa-map-marker-alt me-2 text-muted" style={{ fontSize: "12px" }}></i>
                        <small className="text-truncate">{c.city}, {c.zip_code}</small>
                      </div>
                    </div>
                    {c.address && (
                      <div className="col-12">
                        <div className="d-flex align-items-start customer-info-item">
                          <i className="fas fa-home me-2 text-muted mt-1" style={{ fontSize: "12px" }}></i>
                          <small className="text-truncate">{c.address}</small>
                        </div>
                      </div>
                    )}
                  </div>
                  
                  <div className="d-flex justify-content-between align-items-center">
                    <small className="text-muted">
                      Created: {new Date(c.created_at).toLocaleDateString()}
                    </small>
                    <button
                      className="btn btn-sm btn-outline-danger delete-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteClick(c.id);
                      }}
                      style={{ fontSize: "11px" }}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              ))}
              
              {customersList.length === 0 && (
                <div className="text-center py-4 empty-state">
                  <i className="fas fa-users" style={{ fontSize: "48px" }}></i>
                  <p className="mt-2">No customers found</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div 
        className={`modal fade ${showDeleteModal ? 'show' : ''}`} 
        style={{ display: showDeleteModal ? 'block' : 'none' }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header border-0 pb-2 mb-2">
              <h5 className="modal-title d-flex align-items-center">
                <i className="fas fa-exclamation-triangle text-warning me-2"></i>
                Confirm Deletion
              </h5>
              <button 
                type="button" 
                className="btn-close" 
                onClick={handleDeleteCancel}
              ></button>
            </div>
            <div className="modal-body pt-0">
              {customerToDelete && (
                <div className="text-center">
                  <div className="mb-3">
                    <div 
                      className="delete-modal-avatar rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                      style={{
                        width: "60px",
                        height: "60px",
                        backgroundColor: customerToDelete.gender === "Male" ? "#007bff" : customerToDelete.gender === "Female" ? "#e91e63" : "#6c757d",
                        color: "white",
                        fontSize: "24px",
                        fontWeight: "bold"
                      }}
                    >
                      {customerToDelete.name.charAt(0).toUpperCase()}
                    </div>
                    <h6 className="mb-1">{customerToDelete.name}</h6>
                    <small className="text-muted">{customerToDelete.email}</small>
                  </div>
                  
                  <div className="alert alert-warning warning-alert border-0">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    <strong>Warning:</strong> This action cannot be undone. Are you sure you want to delete this customer?
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer border-0 pt-2">
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={handleDeleteCancel}
              >
                <i className="fas fa-times me-1"></i> Cancel
              </button>
              <button 
                type="button" 
                className="btn btn-danger" 
                onClick={handleDeleteConfirm}
              >
                <i className="fas fa-trash me-1"></i> Delete Customer
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Backdrop */}
      {showDeleteModal && (
        <div 
          className="modal-backdrop fade show"
          onClick={handleDeleteCancel}
        ></div>
      )}
      </div>
      </div>
      <DashboardFooter/>
    </div>
  );
};

export default AddCustomer;
